<template>
    <v-row v-if="!$store.getters.progress" style="height: max-content" class="ma-0 pb-offset pt-4">
        <v-col cols="12" class="pt-0">
            <v-card class="flex pa-0 round-card background-2">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Modifica Vettore</p>
                    <v-spacer></v-spacer>
                </v-card-title>        
                <v-divider></v-divider>
                <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}">
                    <fields-generator
                        :fieldsset.sync="fieldsset"
                        :model="model"
                        ref="fieldsgenerator"
                    ></fields-generator>
                    <small class="px-6">* Indica i campi obbligatori</small>
                </v-container>
            </v-card>
        </v-col>
        <v-col cols="12" class="pt-4">
            <v-card class="flex pa-0 round-card background-2">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Step Peso</p>
                    <v-spacer></v-spacer>
                </v-card-title>        
                <v-divider></v-divider>
                <v-container fluid class="pa-0">
                    <v-data-table
                        :headers="headers"
                        :items="steps"
						hide-default-footer
						disable-pagination
						class="background-2">
						<template v-slot:body="{ items }">
							<tbody>
								<tr v-for="(item, i) in items" :key="i">
									<td style="width: 132px">
										<v-btn small icon class="mx-0" :disabled="item.weight == 0" @click.stop="editItem(item, 'edit')">
											<v-icon color="teal">edit</v-icon>
										</v-btn>
										<v-btn small icon class="mx-0" :disabled="item.weight == 0" @click.stop="editItem(item, 'delete')">
											<v-icon color="pink">delete</v-icon>
										</v-btn>
									</td> 									
                            		<td class="text-center">{{ item.weight }}</td>
								</tr>
							</tbody>
						</template>
                    </v-data-table>


                    <v-dialog v-model="dialog.edit" max-width="500px">
                        <v-card class="round-card background-2">
                            <v-card-title primary-title class="subtitle-1">{{ formTitle }}</v-card-title>
							<v-divider></v-divider>
                            <v-card-text class="pb-0">
                                <v-container>
                                    <v-row class="pb-0 pt-4">
                                        <v-col cols="12" class="px-6">
                                            <v-text-field
                                                type="number"
                                                v-model.number="editedItem.weight"
                                                label="Peso"
                                                single-line
                                                suffix="KG"
                                                :rules="[validationRule]"
												outlined
												dense
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
							<v-divider></v-divider>
                            <v-card-actions class="px-4">
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click.native="close">Annulla</v-btn>
                                <v-btn color="info" :disabled="validateError" text @click.native="save">Salva</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>                        

                    <v-dialog v-model="dialog.delete" max-width="500px">
                        <v-card>
                            <v-card-title primary-title class="title grey lighten-2">Vuoi eliminare questo step?</v-card-title>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click.native="close">Annulla</v-btn>
                                <v-btn color="primary" text @click.native="save">Elimina</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </v-container>
				<v-divider></v-divider>
                <v-card-text style="position: relative">
					<v-btn
						color="primary darken-1"
						dark
						small
						absolute
						bottom
						left
						fab
						@click="editItem()"
						>
						<v-icon>add</v-icon>
					</v-btn>
                </v-card-text>
            </v-card>
        </v-col>


        <v-col cols="12" class="pt-6 pb-12">
            <v-card class="flex pa-0 round-card background-2">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Costi di spedizione</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
				<v-expansion-panels>

					<v-expansion-panel
						v-for="(region, region_name, i) in places"
						:key="i"
						v-model="panel"
						expand>
      					<v-expansion-panel-header>{{ region_name }}</v-expansion-panel-header>
						<v-expansion-panel-content
							ripple
							class="pr-1">
							<v-card class="pa-0 background-2">
								<v-container class="pl-6" fluid>
									<v-row v-for="(province, province_id, p) in region" :key="p + '_p'">
										<v-col class="d-flex justify-start align-center" cols="1"><div class="body-2 pa-2">{{ province.name }}</div></v-col>
										<v-col v-for="(step, s) in steps" cols="2" class="text-left col-lg-1 px-4" :key="s">
											<v-text-field v-if="checkEditIndex(i, p, s)"
												:ref="'step_' + i + '_' + p + '_' + s"
												type="number"
												step="0.01"
												min="0"
												:name="createLabel(s)+province_id"
												v-validate="'decimal:2'"
												:error-messages="errors.collect(createLabel(s)+province_id)"
												:data-vv-name="createLabel(s)+province_id"
												:label="createLabel(s)"
												v-model.number="places[region_name][province_id].costs[s]"
												dense outlined
											>
											</v-text-field>
											<template v-else>
												<small @click="setEditIndex(i, p, s)" style="display: block;">{{ createLabel(s) }}</small>
												<span @click="setEditIndex(i, p, s)" style="border-bottom: 1px solid #444; display: flex;">
														{{ places[region_name][province_id].costs[s] }}
												</span>
											</template>
										</v-col>
									</v-row>
								</v-container>
							</v-card>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
            </v-card>
        </v-col>
        <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
				<v-fab-transition>
					<v-btn
                        v-on="{ ...tooltip }"
						@click.native="editModel()"
						:loading="saved"
						color="primary darken-1"
						dark
						fixed
						bottom
						right
						fab>
						<v-icon>sync</v-icon>
					</v-btn>
				</v-fab-transition>
            </template>
            <span>Aggiorna</span>
        </v-tooltip>
    </v-row>
</template>

<script>
	import Vue from 'vue'
	import FormsMixin from '@/mixins/FormsMixin'

	export default {
		name: 'carrier-edit',
		mixins: [FormsMixin],
		props: {
			id: Number,
			modelDef: String,
			redirect: Object,
		},
		data() {
			return {
				fieldsset: {},
				model: {},
				url: '',
				items: {},
				saved: false,
				editedIndex: -1,
				newItem: {},
				dialog: {edit: false, delete: false},
				editedItem: {},
				defaultItem: {},
				action: '',
				headers: [
					{
						text:'Azioni',
						align: 'left',
						value: 'action',
						sortable: false,
					},
					{
						text:'Peso',
						align: 'center',
						value: 'weight',
					}
				],
				steps: [],
				panel: [],
				places: [],
				validateError: false,
				editIndex : {}
			}
        },
        
		computed: {
			formTitle () {
				return this.editedIndex === -1 ? 'Nuovo Step' : 'Modifica Step'
			},
        },
        
		created() {
			this.axios.get(this.modelDef+'-info/').then(response => {
				// get body data
				this.infoData = response.data.info
				this.axios.get(this.modelDef + '/' + this.id + '/edit').then(response => {
					// get body data
					_.forEach(this.fieldsset.fields, (value, key) => {
						if(value.type === 'checkbox') {
							Vue.set(this.model, value.key, '')
						}
					})
					
					this.model = response.data.model
					this.fieldsset = response.data.fields
					if(response.data.model.steps == null || response.data.model.steps.length == 0) {
						this.steps = [{weight: 0}]
					} else {
						this.steps = response.data.model.steps
					}
					this.places = response.data.places
					this.$store.commit('endProgress')
				}, response => {
					// error callback
				})                
			}, response => {
				// error callback
			})
		},
		methods: {
			setEditIndex(r, p, i) {
					
				this.editIndex = {}
				Vue.set(this.editIndex, r, {[p] : i})
				Vue.nextTick(() => {
					this.$refs['step_' + r + '_' + p + '_' + i][0].focus()
				})
			},
			checkEditIndex(r, p, i) {
				return (this.editIndex[r] != undefined && this.editIndex[r][p] != undefined && this.editIndex[r][p] === i)
			},
			createLabel(s) {
				let label = 'Da ' + this.steps[s].weight
				if(s == this.steps.length - 1) {
					label += ' e oltre'
				} else {
					label += ' a ' + this.steps[s+1].weight
				}
				return label
			},
			editTitleDialog() {
				if (_.has(this.infoData, 'labels')) {
					return this.infoData.labels.showTitleDialog
				}
			},
			editModel() {
				this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
					if (!result) {
						return this.handleValidationErrorAdvanced()
					}
					this.saved = true
					this.model.places = this.places
					this.axios.put(this.modelDef+ '/' + this.id, this.model).then(response => {
						// get body data
						this.model = {}
						this.saved = false
						// Got in show
						this.$eventBusUtility.chooseRedirect(this.$router, response, this.redirect, this.modelDef)
					}, response => {
						// error callback
					})
				}).catch(() => {
				})
			},
			editItem(item, action) {
				if(item) {
					this.editedIndex = this.steps.indexOf(item)
					this.editedItem = Object.assign({}, item)
					this.dialog[action] = true
					this.action = action
				} else {
					this.dialog['edit'] = true
					this.action = 'new'
				}
			},
			save() {
				if (this.editedIndex > -1) {
					Object.assign(this.steps[this.editedIndex], this.editedItem)
				} else {
					this.steps.push(this.editedItem)
				}
				this.axios.put(this.modelDef+ '/' + this.id, {steps: this.steps, action: this.action, item: this.editedItem, item_index: this.editedIndex}).then(response => {
					// get body data
					this.$store.commit('setSnackbar', {timeout: 6000, text: 'Step aggiornati', value: true, color: 'success'})
					if(this.action == 'delete') {
						this.steps.splice(this.editedIndex, 1)
						let newItemIndex = this.editedIndex
						let i = 0
						_.forEach(this.places, (region, region_name) => {
							Vue.set(this.panel, i, false)
							i++
							_.forEach(region, (province, province_id) => {
								province.costs.splice(newItemIndex, 1)
							})
						})
					}
					let oldItemIndex = _.findIndex(this.steps, (s) => {
						return s.weight == this.editedItem.weight 
					})
					this.steps = _.orderBy(this.steps, ['weight'], ['asc'])
						
					// non ho l'editedIndex
					if(this.action == 'new') {
						let newItemIndex = _.findIndex(this.steps, (s) => {
							return s.weight == this.editedItem.weight 
						})
						_.forEach(this.places, (region, region_name) => {
							_.forEach(region, (province, province_id) => {
								province.costs.splice(newItemIndex, 0, 0)
							})
						})
					}
					if(this.action == 'edit') {
						let newItemIndex = _.findIndex(this.steps, (s) => {
							return s.weight == this.editedItem.weight 
						})
						_.forEach(this.places, (region, region_name) => {
							_.forEach(region, (province, province_id) => {
								let oldprice = province.costs[oldItemIndex] 
								let newprice = province.costs[newItemIndex]
								province.costs.splice(oldItemIndex, 1)
								province.costs.splice(newItemIndex, 0, oldprice)
							})
						})
					}
					this.close()
				}, response => {
					// error callback
				})
			},
			close() {
				if(this.action == 'new') {
					this.dialog['edit'] = false
				} else {
					this.dialog[this.action] = false
				}
				this.action = ''
				setTimeout(() => {
					this.editedItem = Object.assign({}, this.defaultItem)
					this.editedIndex = -1
				}, 300)
			},
			all() {
				for(let i = 0; i < this.places.length; i++) {
					this.panel[i] = true
				}
			},
			// Reset the panel
			none () {
				this.panel = []
			},
			validationRule(value) {
				this.validateError = false
				_.forEach(this.steps, (val, key) => {
					if(value == val.weight) {
						this.validateError = true
					}
				})
				return this.validateError ? 'Valore già esistente' : true
			}
		}
	}
</script>